
import { Component, Vue } from 'vue-property-decorator'
import { WinpressService } from '@/services'
import { parseTime } from '@/common/utils'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const dataInitProps = {
    id: 0,
    name: ''
}
@Component({
    name: 'article-demand-detail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = false
    private detailId = ''
    private detail = {
        status: dataInitProps,
        title: '',
        user: { name: '', id: '' },
        type: { name: '' },
        organization: '',
        contact_person: '',
        mobile: '',
        email: '',
        wechat_or_qq: '',
        article: dataInitProps,
        article_level: dataInitProps,
        article_type: dataInitProps,
        release_channel: dataInitProps,
        view_logic: '',
        keywords: '',
        reference_links: [],
        article_count: 0,
        delivery_time: '',
        publish_time: '',
        medium_types: [],
        created_at: '',
        updated_at: ''
    }

    private created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    private async mounted() {
        this.isLoading = true
        await this.getDetail()
        this.isLoading = false
    }

    get matchStatus() {
        const status = {
            1: '已处理',
            2: '未处理'
        }
        return Reflect.get(status, this.detail.status.id)
    }

    private matchButtonType(status: number) {
        return this.detail.status.id === status ? 'primary' : 'default'
    }

    /** 修改申请的信息 */
    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        const result = await WinpressService.getArticleDemandDetail(params)
        if (result.status === 200) {
            // this.detail = result.data
            // this.detail.delivery_time = this.getFormatTime(this.detail.delivery_time) as string
            // this.detail.publish_time = this.getFormatTime(this.detail.publish_time) as string
            const data = result.data
            let referenceLinks = []
            try {
                referenceLinks = typeof data.referenceLinks === 'string' ? JSON.parse(data.referenceLinks) : (data.referenceLinks || [])
            } catch (e) {
                referenceLinks = []
            }
            this.detail = {
                id: data.id || 0,
                title: data.title || '',
                status: { id: data.status || 0, name: '' },
                user: { name: '', id: '' },
                type: { name: '' },
                organization: data.organization || '',
                contact_person: data.contactPerson || '',
                mobile: data.mobile || '',
                email: data.email || '',
                wechat_or_qq: data.wechatOrQq || '',
                article: dataInitProps,
                article_level: { id: 0, name: data.articleLevel || '' },
                article_type: { id: 0, name: data.articleType || '' },
                release_channel: { id: 0, name: data.releaseChannel || '' },
                view_logic: data.viewLogic || '',
                keywords: data.keywords || '',
                reference_links: referenceLinks,
                article_count: data.articleCount || 0,
                delivery_time: this.getFormatTime(data.deliveryTime) as string,
                publish_time: this.getFormatTime(data.publishTime) as string,
                medium_types: data.mediumType ? [{ id: 0, name: data.mediumType }] : [],
                created_at: data.createdAt || '',
                updated_at: data.updatedAt || ''
            }
            this.$title(`${this.detail.title} | 找人写稿详情 - 庖丁`)
        }
    }

    private getFormatTime(dateString: string) {
        if(dateString) {
            return parseTime(dateString,'{y}-{m}-{d}')
        }
        return ''
    }

    // 改变状态
    private async changeStatus(status: number) {
        const params = {
            id: +this.detailId,
            status
        }
        const result = await WinpressService.updateArticleDemand(params)
        if (result.status === 200) {
            this.detail.status.id = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

    private onToLink(url: string) {
        window.open(url)
    }
}
